import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SketchPicker } from 'react-color';

const useStyles = makeStyles(
  {
    root: {
      position: 'relative',
    },
    hex: {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 15,
      lineHeight: 1,
    },
    color: {
      width: 24,
      height: 24,
      borderRadius: 22,
      border: '1px solid #BDBDBD',
    },
    swatch: {
      padding: '10px 15px',
      width: 140,
      display: 'flex',
      borderRadius: 22,
      background: '#EFEFEF',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    popover: {
      position: 'absolute',
      zIndex: 100,
      top: 0,
      left: 145,
    },
    cover: {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    },
  },
  {
    name: 'SketchColor',
  },
);

const SketchColor = ({ colorHex, onChange }) => {
  const classes = useStyles();
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = color => {
    onChange(color.hex);
  };

  return (
    <div className={classes.root}>
      <div className={classes.swatch}>
        <div className={classes.hex}>{colorHex}</div>
        <div
          className={classes.color}
          style={{ backgroundColor: colorHex }}
          onClick={handleClick}
        />
      </div>
      {displayColorPicker ? (
        <div className={classes.popover}>
          <div className={classes.cover} onClick={handleClose} />
          <SketchPicker color={colorHex} onChange={handleChange} />
        </div>
      ) : null}
    </div>
  );
};

export default SketchColor;
